/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pagenotfound2Inputs */

const en_pagenotfound2 = /** @type {(inputs: Pagenotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Not Found`)
};

const de_pagenotfound2 = /** @type {(inputs: Pagenotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite nicht gefunden`)
};

/**
* | output |
* | --- |
* | "Page Not Found" |
*
* @param {Pagenotfound2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pagenotfound2 = /** @type {((inputs?: Pagenotfound2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagenotfound2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pagenotfound2(inputs)
	return de_pagenotfound2(inputs)
});
export { pagenotfound2 as "pageNotFound" }